import { render, staticRenderFns } from "./PTabItem.vue?vue&type=template&id=5e333254&scoped=true&"
import script from "./PTabItem.vue?vue&type=script&lang=js&"
export * from "./PTabItem.vue?vue&type=script&lang=js&"
import style0 from "./PTabItem.vue?vue&type=style&index=0&id=5e333254&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e333254",
  null
  
)

export default component.exports